import { render, staticRenderFns } from "./KnowledgeContentContent.vue?vue&type=template&id=9cc167c6&"
import script from "./KnowledgeContentContent.vue?vue&type=script&lang=js&"
export * from "./KnowledgeContentContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports